import React, { Suspense, useContext, useEffect, useState } from "react";
import "./App.css";
import { Route, Routes } from "react-router-dom";
import "./common/common_css/Common_Css.css";
import "./common/common_css/Form_Css.css";
import { Spinner } from "react-bootstrap";
import { Context } from "./utils/context";
import Support_lottie from "./assets/animation/support_lottie/Support_lottie";
import Terms_And_Condition_Lottie from "./assets/animation/terms_and_condition_lottie/Terms_And_Condition_Lottie";
import Tl_lottie from "./assets/animation/tl_lottie/Tl_lottie";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { APIS } from "./utils/APIS";
import { GET } from "./utils/Methods";
import Terms_conditions_modal from "./common/common_modal/service_center_terms_and_condition/Terms_conditions_modal";

// Containers
const DefaultLayout = React.lazy(() => import("./layout/DefaultLayout"));

// Pages
const Login = React.lazy(() => import("./components/login/Login"));
const Page404 = React.lazy(() => import("./components/page404/Page404"));
const Page500 = React.lazy(() => import("./components/page500/Page500"));

function App() {
  const { signin, user } = useContext(Context);


  const [modalShow, setModalShow] = useState(false);
  const [popup, setPopup] = useState(null); // "tl" or "support"

  const handleClick = (type) => {
    setPopup(type); // open popup
  };

  const handleClose = () => {
    setPopup(null); // close popup
  };

  const [appSetupData, setAppSetupData] = useState("");


  const getAppSetup = async () => {
    const res = await GET(`${APIS.Commons?.appSetup}`);
    setAppSetupData(res.data);
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  const [DashboardData, setDashboardData] = useState("");


  const GetData = async () => {
    const res = await GET(`${APIS.Commons.tnc}`);
    setDashboardData(res.data);
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      <div className="full_container_holder">
        <Suspense
          fallback={
            <div className="pt-3 text-center">
              <Spinner
                animation="grow"
                variant="primary"
                style={{
                  width: "4rem",
                  height: "4rem",
                  color: "#fbca06",
                  background: "#fbca06",
                }}
              />
            </div>
          }
        >
          {!signin ? (
            <Login />
          ) : (
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/404" element={<Page404 />} />
              <Route exact path="/500" element={<Page500 />} />
              <Route path="*" element={<DefaultLayout />} />
            </Routes>
          )}
        </Suspense>

        {/* Sticky Lottie Icons */}

        <div className="sticky_icon_holder">
          {/* TL Lottie with Tooltip */}
          {window.location.pathname !== "/" && (
            <OverlayTrigger
              placement="left"
              overlay={<Tooltip id="tooltip-tl">TL Contact</Tooltip>}
            >
              <div
                onClick={() => handleClick("tl")}
                style={{ cursor: "pointer" }}
              >
                <Tl_lottie />
              </div>
            </OverlayTrigger>
          )}

          {/* Support Lottie with Tooltip */}
          <OverlayTrigger
            placement="left"
            overlay={<Tooltip id="tooltip-support">Support Contact</Tooltip>}
          >
            <div
              onClick={() => handleClick("support")}
              style={{ cursor: "pointer" }}
            >
              <Support_lottie />
            </div>
          </OverlayTrigger>

          <OverlayTrigger
            placement="left"
            overlay={
              <Tooltip id="tooltip-support">Terms And Condition</Tooltip>
            }
          >
            <div
              onClick={() => setModalShow(true)}
              style={{ cursor: "pointer" }}
            >
              <Terms_And_Condition_Lottie />
            </div>
          </OverlayTrigger>
        </div>

        {/* Custom Modal-style Popup */}
        {popup && (
          <div
            className="custom_modal_overlay"
            onClick={handleClose} // click on background closes modal
          >
            <div
              className="custom_modal"
              onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside box
            >
              <button className="custom_close_btn" onClick={handleClose}>
                ✕
              </button>

              {popup === "tl" ? (
                <>
                  <h4>Team Leader Contact</h4>
                  <p>
                    📞 +91{" "}
                    {user?.details?.admin_service_centers?.[0]?.User
                      ?.contact_no || "N/A"}
                  </p>
                </>
              ) : (
                <>
                  <h4>Support Contact</h4>
                  <p>📞 +91 {appSetupData?.contact_no || "N/A"}</p>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      <Terms_conditions_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        DashboardData={DashboardData}
      />
    </>
  );
}

export default App;
